// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-fXz","newExpiryDate":"styles_newExpiryDate__COTYV","footer":"styles_footer__2E0oO"};